/**
 * GoogleMaps JS controller.
 *
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class GoogleMaps
 */
class GoogleMaps {

    /**
     * Cache dom elements for use in the class's methods.
     */
    cache() {
        this.map = $( '.js-google-maps' );
    }

    /**
     * All common events
     * @return {void}
     */
    events() {
        this.initMap();
    }

    /**
     * Initialize map.
     */
    initMap() {

        this.map.each( ( i, el ) => {

             /**
             * Find zoom level from themeData.
             * note: themeData is passed to JavaScript with wp-localize-script in SetUp.php.
             */
            const zoomLevel = $.parseJSON( themeData.zoomLevel );

			const geoCoder = new google.maps.Geocoder();
            const address = el.dataset.address;

            // Address Latitude.
            const lat = el.dataset.lat;

            // Address Longitude.
            const lng = el.dataset.lng;

            const myLatlng = new google.maps.LatLng( lat, lng );

            // Place the marker on the map at construction of the marker using the map property in the marker options.
			geoCoder.geocode({address}, ( res, status ) => {

				if ( status === google.maps.GeocoderStatus.OK ) {

					const newMap = new google.maps.Map( el, {
						zoom: zoomLevel,
						center: myLatlng,
						disableDefaultUI: true,
						draggable: false
					});

					const marker = new google.maps.Marker({
						position: myLatlng,
						map: newMap,
						title: address
					});
				}
			});

		});

    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
    }
}

// Export the class reference.
module.exports = GoogleMaps;



// WEBPACK FOOTER //
// ../vaasa/assets/scripts/google-maps.js